var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1967 15.182L18.2573 16.2426L22.5 12L18.2573 7.75732L17.1967 8.81801L19.6287 11.25H9V12.75H19.6287L17.1967 15.182Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3511 18.364C16.6514 20.0639 14.3915 21 11.9876 21C9.58355 21 7.32328 20.0639 5.62331 18.364C3.9233 16.6641 3 14.404 3 12C3 9.5962 3.9233 7.33617 5.62336 5.6362C7.32337 3.93623 9.58359 3 11.9876 3C14.3913 3 16.6513 3.93623 18.3511 5.63616C18.469 5.75429 18.5836 5.87562 18.6949 6H20.6041C18.7069 3.27994 15.5553 1.5 11.9876 1.5C6.18848 1.5 1.5 6.20147 1.5 12C1.5 17.7991 6.18848 22.5 11.9876 22.5C15.5554 22.5 18.7072 20.7202 20.6043 18H18.6951C18.5838 18.1245 18.4691 18.2459 18.3511 18.364Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.477d7a2cbe681dd86b4b38cc38f331e0.svg";
export { ForwardRef as ReactComponent };